export interface AnalyticsEventMap {
  run_start: { seed: number; mode: 'normal' | 'endgame' };
  run_end: { result: 'victory' | 'defeat'; wave: number; duration: number };
  endgame_test_complete: {
    result: 'victory' | 'defeat';
    duration: number;
    kills: number;
  };
  upgrade_selected: { upgradeId: string; rank: number };
  reroll_used: Record<string, never>;
  synergy_unlocked: { synergyId: string };
  evolution_triggered: { evolutionId: string };
  workshop_purchase: { branch: string; level: number };
  core_selected: { coreId: string };
  cosmetic_selected: { type: 'core' | 'skill'; id: string };
}

export interface AnalyticsRecord<K extends keyof AnalyticsEventMap = keyof AnalyticsEventMap> {
  event: K;
  at: number;
  data: AnalyticsEventMap[K];
}

export interface AnalyticsPort {
  track<K extends keyof AnalyticsEventMap>(event: K, data: AnalyticsEventMap[K]): void;
  export(): string;
}

export class LocalAnalytics implements AnalyticsPort {
  private readonly records: AnalyticsRecord[] = [];

  track<K extends keyof AnalyticsEventMap>(event: K, data: AnalyticsEventMap[K]): void {
    this.records.push({ event, at: Date.now(), data } as AnalyticsRecord);
  }

  export(): string {
    return JSON.stringify(this.records, null, 2);
  }
}
